<template>
  <div id="transfer" dir="rtl">
    <loading v-if="loadingRender"></loading>
    <panel
      class="no-print"
      Title="فرم انتقال وجه"
      Des="از طریق این فرم می‌توانید بین حساب خود و اعضای وابسته درخواست انتقال وجه خود را ثبت نمایید"
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></panel>
    <net-pa-card class="no-print">
      <template slot="header">
        <h6 class="text-right">
          <i class="fas fa-exchange-alt"></i>
          فرم انتقال وجه
        </h6>
      </template>
      <template slot="content">
        <div class="Transfer-form">
          <!-- حساب مبدأ -->
          <div class="Transfer-field">
            <label class="Transfer-label" for="cmbTaahodat">حساب مبدأ</label>
            <select
              v-if="IsLoad"
              @change="cheangcmbTaahodat()"
              name="cmbTaahodat"
              id="cmbTaahodat"
              class="form-control Pointer"
              v-model="Resultcmb"
            >
              <option selected value="-1">-- انتخاب حساب --</option>
              <option
                v-for="item in this.ListModel"
                :key="item.id"
                :value="item"
              >
                {{ item.vcodeDesNo }} {{ item.nameFamily }}
              </option>
            </select>
            <div v-else class="Transfer-skeleton">
              <i class="fas fa-circle-notch fa-spin"></i>
              در حال بارگذاری حساب‌ها ...
            </div>
          </div>

          <div
            class="Transfer-balance"
            :class="{ 'is-empty': sourceAccount === null }"
          >
            <span class="Transfer-balance__label">مبلغ قابل برداشت</span>
            <strong class="Transfer-balance__value">
              <template v-if="sourceAccount !== null">
                {{ $Comma3ragham(Number(sourceAccount.ghabelBardasht)) }}
                <small>{{ $GetVahedPool() }}</small>
              </template>
              <template v-else>—</template>
            </strong>
          </div>
          <div v-if="sourceAccount !== null" class="Transfer-meta">
            <div class="Transfer-meta__row">
              <span>موجودی حساب</span>
              <b>{{
                $Comma3ragham(
                  Number(sourceAccount.mande) +
                    Number(sourceAccount.sumMabTaeedNaShode),
                )
              }}</b>
            </div>
          </div>

          <!-- حساب مقصد -->
          <div class="Transfer-field Transfer-field--spaced">
            <span class="Transfer-label">حساب مقصد</span>
            <div class="Transfer-segmented" role="radiogroup">
              <label
                v-for="opt in DestTypes"
                :key="opt.value"
                class="Transfer-segment"
                :class="{ 'is-active': transferDestType === opt.value }"
              >
                <input
                  type="radio"
                  name="transferDestType"
                  :value="opt.value"
                  :checked="transferDestType === opt.value"
                  @click="setTransferDestType(opt.value)"
                />
                <i :class="opt.icon"></i>
                <span>{{ opt.title }}</span>
              </label>
            </div>
          </div>

          <div v-if="IsHesab == true" class="Transfer-field">
            <label class="Transfer-label" for="cmbTaahodatDest"
              >انتخاب حساب مقصد</label
            >
            <select
              name="cmbTaahodatDest"
              id="cmbTaahodatDest"
              class="form-control Pointer"
              v-model="Resultcmb2"
            >
              <option v-if="this.IsLoad2 == false" value="-2">
                ابتدا حساب مبدأ را انتخاب نمایید
              </option>
              <option selected value="-1">-- انتخاب حساب --</option>
              <option
                v-for="item in this.ListModel2"
                :key="item.id"
                :value="item"
              >
                {{ item.vcodeDesNo }} {{ item.nameFamily }}
              </option>
            </select>
            <div
              v-if="Resultcmb2 != null && Resultcmb2 != '-1'"
              class="Transfer-meta mt-2"
            >
              <div class="Transfer-meta__row">
                <span>موجودی حساب مقصد</span>
                <b>{{
                  $Comma3ragham(
                    Number(Resultcmb2.mande) +
                      Number(Resultcmb2.sumMabTaeedNaShode),
                  )
                }}</b>
              </div>
              <div class="Transfer-meta__row">
                <span>قابل برداشت حساب مقصد</span>
                <b>{{ $Comma3ragham(Number(Resultcmb2.ghabelBardasht)) }}</b>
              </div>
            </div>
          </div>

          <div v-if="IsHesab == false" class="Transfer-field">
            <label class="Transfer-label" for="VCode"
              >شماره حساب | تسهیلات مقصد</label
            >
            <div class="Transfer-vcode" dir="ltr">
              <input
                v-if="$session.get('CustCode') != '934'"
                autocomplete="off"
                class="form-control text-center"
                id="VCode"
                type="text"
                placeholder="شماره حساب | تسهیلات"
                v-model="VCode"
                v-mask="'###-##-#######'"
                @keyup.enter="CheckupVcode()"
              />
              <input
                v-else
                autocomplete="off"
                class="form-control text-center"
                id="VCode"
                type="text"
                placeholder="شماره حساب | تسهیلات"
                v-model="VCode"
                v-mask="'###-##-###########'"
                @keyup.enter="CheckupVcode()"
              />
              <button
                type="button"
                class="Transfer-vcode__check"
                title="بررسی شماره حساب"
                @click="CheckupVcode()"
              >
                <i class="fa fa-search"></i>
                <span>بررسی</span>
              </button>
            </div>
          </div>

          <div
            v-if="IsHesab == false && Result != null"
            class="Transfer-estelam"
          >
            <div class="Transfer-estelam__row">
              <span>صاحب حساب</span>
              <b>{{ Result.nameFamily }}</b>
            </div>
            <div class="Transfer-estelam__row">
              <span>نوع حساب</span>
              <b>{{ Result.desNoe }}</b>
            </div>
            <div v-if="tblSarfaslTypeId" class="Transfer-estelam__row">
              <span>مبلغ قابل پرداخت</span>
              <b>{{ $Comma3ragham(sumGhabelPar) }}</b>
            </div>
            <div v-if="tblSarfaslTypeId" class="Transfer-estelam__row">
              <span>مبلغ جریمه</span>
              <b>{{ $Comma3ragham(wwwJarime) }}</b>
            </div>
          </div>

          <div v-if="IsHesab == false && Result != null" class="Transfer-field">
            <label class="Transfer-toggle" for="SaveShebaOrCard">
              <span>ذخیره اطلاعات حساب برای دفعات بعدی</span>
              <span class="Transfer-switch">
                <input
                  type="checkbox"
                  v-model="SaveHesab"
                  id="SaveShebaOrCard"
                />
                <span class="Transfer-switch__track" aria-hidden="true"></span>
              </span>
            </label>
          </div>

          <div v-if="SaveDetailHesab" class="Transfer-saved" :key="KEY">
            <div class="Transfer-saved__head">حساب‌های ذخیره‌شده</div>
            <div class="Transfer-saved__list">
              <div
                v-if="ListSaveHesab.length == 0"
                class="Transfer-saved__empty"
              >
                حساب ذخیره‌شده‌ای وجود ندارد
              </div>
              <div
                class="Transfer-saved__item"
                :class="{ 'is-selected': item.selected == true }"
                v-for="(item, key) in ListSaveHesab"
                :key="key"
              >
                <div class="Transfer-saved__info">
                  <div class="Transfer-saved__num" dir="ltr">
                    {{ item.shebaOrCardNum }}
                  </div>
                  <div class="Transfer-saved__owner">
                    {{ item.sahebShebaOrCard }}
                  </div>
                </div>
                <div class="Transfer-saved__actions">
                  <button
                    v-if="item.selected != true"
                    type="button"
                    class="Transfer-icon-btn is-select"
                    title="انتخاب"
                    @click="SelectSaveHesab(item.id)"
                  >
                    <i class="fa fa-check"></i>
                  </button>
                  <span v-else class="Transfer-icon-btn is-done">
                    <i class="fa fa-check"></i>
                  </span>
                  <button
                    type="button"
                    class="Transfer-icon-btn is-remove"
                    title="حذف"
                    @click="RemoveShebeOrCard(item)"
                  >
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- مبلغ -->
          <div class="Transfer-field Transfer-field--spaced">
            <label class="Transfer-label" for="txtMablagh"
              >مبلغ انتقال ({{ $GetVahedPool() }})</label
            >
            <div class="Transfer-amount">
              <input
                type="text"
                ref="txtMablagh"
                id="txtMablagh"
                tabindex="1"
                inputmode="numeric"
                autocomplete="off"
                placeholder="0"
                dir="ltr"
                class="form-control 3ragham Transfer-amount__input"
                v-model="txtMablagh"
                @keypress="$ValidNumber($event, 11)"
              />
              <span class="Transfer-amount__unit">{{ $GetVahedPool() }}</span>
            </div>
            <div class="Transfer-amount__foot">
              <span class="Transfer-amount__words">{{ Mab2persian }}</span>
              <button
                v-if="
                  sourceAccount !== null &&
                  Number(sourceAccount.ghabelBardasht) > 0
                "
                type="button"
                class="Transfer-link-btn"
                @click="fillMaxAmount"
              >
                حداکثر مبلغ
              </button>
            </div>
          </div>

          <div class="Transfer-field">
            <label class="Transfer-label" for="TransferDescription"
              >توضیحات (اختیاری)</label
            >
            <textarea
              id="TransferDescription"
              class="form-control"
              placeholder="توضیحات"
              rows="3"
              v-model="Description"
            ></textarea>
          </div>

          <!-- تایید نهایی -->
          <div class="Transfer-field Transfer-captcha">
            <span class="Transfer-label">کد امنیتی</span>
            <CaptchaBox ref="captchaRef" @update="onCaptchaValid"></CaptchaBox>
          </div>

          <button
            v-if="!twoLevel"
            type="button"
            :disabled="!CaptchaValid"
            class="Transfer-submit"
            @click="checkSms()"
          >
            <i class="fas fa-check-circle"></i>
            {{ GetMablagh }}
          </button>

          <div v-if="twoLevel == true" class="Transfer-twostep">
            <label class="Transfer-label" for="TransferTwoStep"
              >رمز پیامک شده را وارد کنید</label
            >
            <div class="Transfer-twostep__row">
              <input
                id="TransferTwoStep"
                v-model="twstepCode"
                type="number"
                inputmode="numeric"
                class="form-control text-center"
              />
              <button
                type="button"
                @click="CheckCode"
                class="Transfer-submit Transfer-submit--sm"
              >
                تایید
              </button>
            </div>
          </div>
        </div>
      </template>
    </net-pa-card>
  </div>
</template>
<script>
import Num2persian from "num2persian";
import NetPaCard from "../Tools/NetPa/NetPaCard.vue";
import Panel from "../Tools/NetPa/Panel.vue";
import loading from "../Tools/NetPa/Loading.vue";
import CaptchaBox from "../CmpLogin/CaptchaBox.vue";

export default {
  components: {
    NetPaCard,
    Panel,
    loading,
    CaptchaBox,
  },
  data() {
    return {
      captchaText: "",
      captchaId: "",
      CaptchaValid: false,
      twstepCode: "",
      twoLevel: false,
      KEY: 0,
      ListSaveHesab: [],
      SaveDetailHesab: false,
      SaveHesab: false,
      DataAxios_Variz: {
        ArryfildValue: {},
        Method: "Post",
        Action: "VarizGorohi/SetVarizGorohi",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxios_cmbTaahodat: {
        ArryfildValue: "",
        Method: "Post",
        Action: "ListTaahodat",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxios_SahebHesab: {
        ArryfildValue: "",
        Method: "Post",
        Action: "ListTaahodat/TaahodatSahebHesab",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxios_Enteghal: {
        ArryfildValue: "",
        Method: "Post",
        Action: "EnteghalVajh",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxiosRowVCode: {
        ArryfildValue: "",
        Method: "Post",
        Action: "TaahodatByVCNew",
        Token: this.$session.get("TokenNetPa"),
      },
      Description: "",
      IsLoad: false,
      Resultcmb: null,
      loadingRender: false,
      ListModel: null,
      ListModelSahebHesab: null,
      IsLoad2: false,
      ListModel2: null,
      ListModelSahebHesab2: null,
      Resultcmb2: null,
      txtMablagh: 0,
      IsHesab: true,
      transferDestType: "self",
      DestTypes: [
        { value: "self", icon: "fas fa-user", title: "حساب خود" },
        { value: "others", icon: "fas fa-users", title: "حساب دیگران" },
        { value: "saved", icon: "fas fa-bookmark", title: "ذخیره‌شده‌ها" },
      ],
      VCode: "",
      Result: null,
      wwwJarime: 0,
      sumGhabelPar: 0,
      tblSarfaslTypeId: false,
      MabFormulaJarime: 0,
      WwwtblAzaId: null,
      BnpCashDBtblTaahodatId: null,
      BnpCashDBtblAzaId: null,
    };
  },
  mounted() {
    this.GetData();
  },
  updated() {
    this.$PutCommatoInput();
  },
  methods: {
    onCaptchaValid({ valid, captchaId, userInput }) {
      this.CaptchaValid = valid;
      this.captchaId = captchaId;
      this.captchaText = userInput;
    },
    refreshCaptcha() {
      this.$refs.captchaRef.generateCaptcha();
    },
    GetData() {
      const formData = new FormData();
      let info;
      formData.append(
        "wwwtblAzaId",
        this.$session.get("UserInfoNetPa").wwwtblAzaId,
      );
      formData.append("wwwtblSarfaslTypeId", 2);
      this.DataAxios_cmbTaahodat.ArryfildValue = formData;
      this.$PostFormData(this.DataAxios_cmbTaahodat)
        .then((data) => {
          this.IsLoad = true;
          this.ListModel = data.filter((x) => x.tblSarfaslTypeId != 6);
          console.log(this.ListModel);
          console.log(data);
          this.Resultcmb = "-1";
        })
        .finally(() => {
          const formData = new FormData();
          formData.append(
            "wwwtblAzaId",
            this.$session.get("UserInfoNetPa").wwwtblAzaId,
          );
          formData.append("wwwtblSarfaslTypeId", 2);
          this.DataAxios_SahebHesab.ArryfildValue = formData;
          this.$PostFormData(this.DataAxios_SahebHesab).then((data) => {
            if (data.length > 0) {
              this.IsLoad = true;
              this.ListModelSahebHesab = data;
              for (
                let index = 0;
                index < this.ListModelSahebHesab.length;
                index++
              ) {
                if (this.ListModelSahebHesab[index].hasHaghEmza == true) {
                  info = this.ListModelSahebHesab[index];
                  this.ListModel.push(info);
                }
              }
            }
          });
        });
    },
    fillMaxAmount() {
      if (this.sourceAccount !== null) {
        this.txtMablagh = this.$Comma3ragham(
          Number(this.sourceAccount.ghabelBardasht),
        );
      }
    },
    setTransferDestType(type) {
      this.transferDestType = type;
      if (type === "self") {
        this.ShowHesab(true);
        this.SaveDetailHesab = false;
      } else if (type === "others") {
        this.ShowHesab(false);
        this.SaveDetailHesab = false;
      } else if (type === "saved") {
        this.SaveDetailHesab = true;
        this.IsHesab = null;
        this.GetDataShebaOrCard();
      }
    },
    ShowHesab(status) {
      this.IsHesab = status;
      if (!status) {
        this.Result = null;
      }
    },
    CheckupVcode() {
      if (this.VCode != "") {
        this.loadingRender = true;
        this.Shenase = "";
        const formData = new FormData();
        formData.append("VCode", this.$Encryption(this.VCode));
        this.DataAxiosRowVCode.ArryfildValue = formData;

        this.$PostFormData(this.DataAxiosRowVCode).then((data) => {
          if (data != null) {
            //Maghsad
            this.Result = data;
            this.Resultcmb2 = null;
            this.loadingRender = false;
            if (data.tblSarfaslTypeId == 1) {
              // console.log('data*/*/*',data);
              this.tblSarfaslTypeId = true;
              this.sumGhabelPar = data.sumGhabelPar;

              this.wwwJarime = data.wwwJarime;
              this.txtMablagh = this.$Comma3ragham(data.sumGhabelPar);

              this.WwwtblAzaId = data.wwwtblAzaId;
              this.BnpCashDBtblTaahodatId = data.bnpCashDBtblTaahodatId;
              this.BnpCashDBtblAzaId = data.bnpCashDBtblAzaId;
            } else {
              this.tblSarfaslTypeId = false;
              this.sumGhabelPar = 0;
              this.wwwJarime = 0;
              this.txtMablagh = 0;
            }
          } else {
            this.$mySweetDefaultTost(
              "خطا",
              "شماره حساب وارد شده صحیح نمی باشد .",
              "error",
              2500,
            );
            this.Result = null;
            this.loadingRender = false;
          }
        });
      } else {
        this.$mySweetDefault(
          "خطا",
          "شماره حساب نمی تواند خالی می باشد ",
          "error",
          2500,
        );
        this.Result = null;
      }
    },
    cheangcmbTaahodat() {
      if (this.Resultcmb != undefined || this.Resultcmb.id != "-1") {
        const formData = new FormData();
        let info;
        formData.append(
          "wwwtblAzaId",
          this.$session.get("UserInfoNetPa").wwwtblAzaId,
        );
        formData.append("wwwtblSarfaslTypeId", 2);
        this.DataAxios_cmbTaahodat.ArryfildValue = formData;
        this.$PostFormData(this.DataAxios_cmbTaahodat)
          .then((data) => {
            this.IsLoad2 = true;
            this.ListModel2 = data.filter(
              (x) => x.id != this.Resultcmb.id && x.tblSarfaslTypeId != 6,
            );
          })
          .finally(() => {
            const formData = new FormData();
            formData.append(
              "wwwtblAzaId",
              this.$session.get("UserInfoNetPa").wwwtblAzaId,
            );
            formData.append("wwwtblSarfaslTypeId", 2);
            this.DataAxios_SahebHesab.ArryfildValue = formData;
            this.$PostFormData(this.DataAxios_SahebHesab).then((data) => {
              if (data.length > 0) {
                this.IsLoad2 = true;
                this.ListModelSahebHesab2 = data.filter(
                  (x) => x.id != this.Resultcmb.id,
                );
                for (
                  let index = 0;
                  index < this.ListModelSahebHesab2.length;
                  index++
                ) {
                  info = this.ListModelSahebHesab2[index];
                  this.ListModel2.push(info);
                }
              }
            });
          });
      }
    },

    checkSms() {
      if (
        this.$session.get("CustCode") == "801" ||
        this.$session.get("CustCode") == "255"
      ) {
        this.sendTwoStepCode();
      } else this.SabtEnteghal();
    },
    sendTwoStepCode() {
      this.twoLevel = true;
      var DataAxiosSms = {
        Method: "GET",
        Token: this.$session.get("TokenNetPa"),
        Action:
          "twoStepVerification?wwwtblAzaId=" +
          this.$session.get("UserInfoNetPa").wwwtblAzaId,
        ArryfildValue: null,
      };
      this.$PostData(DataAxiosSms).then((result) => {
        if (result.status == "success") {
          this.$mySweetDefaultTost("", result.msg, "success", 2800);
        }
      });
    },
    CheckCode() {
      var DataAxiosCheckCode = {
        Method: "POST",
        Token: this.$session.get("TokenNetPa"),
        Action: "twoStepVerification",
        ArryfildValue: {
          wwwtblAzaId: this.$session.get("UserInfoNetPa").wwwtblAzaId,
          Code: this.twstepCode + "",
        },
      };
      this.$PostData(DataAxiosCheckCode).then((result) => {
        if (result.status) {
          this.SabtEnteghal();
        } else {
          this.$mySweetDefaultTost(
            "خطا",
            "رمز دو مرحله ای وارد شده صحیح نمیباشد. دوباره تلاش کنید",
            "error",
            2800,
          );
          this.refreshCaptcha();
        }
      });
    },

    SabtEnteghal() {
      if (this.txtMablagh <= 0) {
        this.$mySweetDefaultTost(
          "عدم ورود مبلغ صحیح",
          "مبلغ انتقال وجه صفر یا وارد نشده است",
          "warning",
          3000,
        );
        this.refreshCaptcha();
      } else {
        if (
          this.Resultcmb == null ||
          (this.Resultcmb2 == null && this.Result == null)
        ) {
          this.$mySweetDefaultTost(
            "عدم انتخاب حساب",
            "حساب مبداء یا مقصد انتخاب نشده است",
            "warning",
            3000,
          );
          this.refreshCaptcha();
        } else {
          if (
            Number(this.txtMablagh.replaceAll(/,/g, "")) <
            Number(this.sumGhabelPar)
          ) {
            var MablaghJarime = this.wwwJarime > 0 ? this.wwwJarime : 0;
            if (this.$session.get("CustCode") == 561) {
              this.MabFormulaJarime =
                (Number(this.txtMablagh.replaceAll(/,/g, "")) /
                  Number(this.sumGhabelPar)) *
                MablaghJarime;
            } else {
              this.MabFormulaJarime =
                (Number(this.txtMablagh.replaceAll(/,/g, "")) /
                  (Number(this.sumGhabelPar) - MablaghJarime)) *
                MablaghJarime;
            }
            // console.log(this.MabFormulaJarime);
          } else {
            this.MabFormulaJarime = this.wwwJarime > 0 ? this.wwwJarime : 0;
            // console.log(this.MabFormulaJarime);
          }
          let ghabelBardasht = Number(this.Resultcmb.ghabelBardasht);
          let MablaghEnteghal = Number(this.txtMablagh.replaceAll(",", ""));

          if (MablaghEnteghal <= ghabelBardasht) {
            //Checkup Mahdodiyat enteghal dar roz
            if (MablaghEnteghal < 10000) {
              this.$mySweetDefaultTost(
                "مبلغ انتقال نا درست",
                " مبلغ انتقال نمیتواند کمتر از 10,000" +
                  this.$GetVahedPool() +
                  "باشد",
                "warning",
                3000,
              );
              this.refreshCaptcha();
            } else {
              this.ChekMojavez(
                this.Resultcmb.id,
                this.txtMablagh.replaceAll(",", ""),
              );
            }
            //................................................................
          } else {
            this.$mySweetDefaultTost(
              "عدم انتقال وجه",
              " مبـلـغ وارد شده بیشـتر از مبلغ قابل برداشت  حسـاب " +
                this.Resultcmb.desNoe +
                " میباشد ",
              "warning",
              3000,
            );
            this.refreshCaptcha();
          }
        }
      }
    },
    ChekMojavez(wwwtblTaahodatId, Amount) {
      var DataAxios_Check = {
        ArryfildValue: "",
        Method: "Post",
        Action: "TanzimatNoe/ChekMojavez",
        Token: this.$session.get("TokenNetPa"),
      };
      const formData = new FormData();
      formData.append("wwwtblTaahodatId", wwwtblTaahodatId);
      formData.append("Amount", Amount);
      formData.append("IsBardasht", false);
      DataAxios_Check.ArryfildValue = formData;
      this.$PostFormData(DataAxios_Check).then((data) => {
        if (data.status == "Ok") {
          if (data.data[0].isMojaz == 1) {
            // console.log(this.Resultcmb2);
            let result;
            if (this.Resultcmb2 != null) {
              result = this.Resultcmb2;
              // result['nameFamily']=this.$session.get('UserInfoNetPa').ozvName + ' ' + this.$session.get('UserInfoNetPa').ozvFamily
              result["nameFamily"] = " ";
            } else {
              result = this.Result;
            }
            this.$SweetQustion(
              "اطمینان از انتقال وجه",
              " از انتقال وجه به مبلغ " +
                this.$Comma3ragham(Number(Amount.replace(/,/g, ""))) +
                this.$GetVahedPool() +
                " به شماره حساب | شماره تسهیلات " +
                this.$b_InvertCode(result.vCode, "-") +
                " _ " +
                result.desNoe +
                "  به نام آقا | خانم " +
                " [ " +
                result.nameFamily +
                " ] " +
                " اطمینان دارید ؟ ",
              "question",
              "تایید و انتقال",
              "انصراف",
              null,
              this.Enteghal,
              this.Cancel,
            );
          } else {
            this.$mySweetDefaultTost(
              "محدودیت انتقال روزانه",
              "  سقف انتقال وجه شما در امروز به پایان رسیده و یا مبلغ وارد شده بیشتر از حد مجاز روزانه" +
                " ( " +
                this.$Comma3ragham(data.data[0].maxEnteghal) +
                " ) " +
                this.$GetVahedPool() +
                " می باشد",
              "error",
              3500,
            );
            this.refreshCaptcha();
          }
        } else {
          this.$mySweetDefaultTost(
            "خطایی رخ داده",
            "در انتقال وجه خطایی رخ داده لفا کمی بعد دوباره تلاش فرمایید",
            "error",
            3500,
          );
          this.refreshCaptcha();
        }
      });
    },
    Enteghal() {
      if (this.SaveHesab == true) {
        this.SaveDataShebaOrCard().then((data) => {
          if (data == true) {
            this.$mySweetDefaultTost(
              "عملیات موفق",
              "ذخیره اطلاعات حساب | تسهیلات با موفقیت انجام گردید",
              "success",
              2000,
            );
          } else {
            this.$mySweetDefaultTost(
              "عملیات ناموفق",
              "ذخیره اطلاعات حساب | تسهیلات با خطا روبه رو شد",
              "danger",
              2000,
            );
          }
        });
      }
      //// کدهای ثبت واریز گروهی
      const WwwtblVarizGorohiRiz = [];
      if (this.tblSarfaslTypeId == true) {
        /*wwwtblTaahodatIdBestanKar*/
        WwwtblVarizGorohiRiz.push({
          WwwtblTaahodatId:
            this.Result != null ? this.Result.id : this.Resultcmb2.id,
          Mablagh: Number(this.txtMablagh.replaceAll(/,/g, "")),
          SharhRiz: "واریز به حساب / تسهیلات ",
          WwwtblAzaId: this.WwwtblAzaId,
          BnpCashDBtblTaahodatId: this.BnpCashDBtblTaahodatId,
          BnpCashDBtblAzaId: this.BnpCashDBtblAzaId,
          MablaghJarime: this.wwwJarime,
          TarixGhest: "",
          IsTaahodatRiz: false,
        });
        /*wwwtblTaahodatIdBestanKar*/

        this.DataAxios_Variz.ArryfildValue.Mablagh = Number(
          this.txtMablagh.replaceAll(/,/g, ""),
        );
        this.DataAxios_Variz.ArryfildValue.CodeRahgiri = 0;
        this.DataAxios_Variz.ArryfildValue.Tarix = this.$store.state.JalaliDate;
        this.DataAxios_Variz.ArryfildValue.Sharh = " انتقال وجه ";
        this.DataAxios_Variz.ArryfildValue.ZamanInsert =
          this.$store.state.JalaliDate;
        this.DataAxios_Variz.ArryfildValue.CustCode = Number(
          this.$session.get("UserInfoNetPa").custCode,
        );
        this.DataAxios_Variz.ArryfildValue.tblComboIdVaziatGrp312 = 5538;
        this.DataAxios_Variz.ArryfildValue.wwwtblAzaId =
          this.$session.get("UserInfoNetPa").wwwtblAzaId;
        this.DataAxios_Variz.ArryfildValue.StatusVariz = 2;
        this.DataAxios_Variz.ArryfildValue.WwwtblVarizGorohiRiz =
          WwwtblVarizGorohiRiz;
        this.$PostData(this.DataAxios_Variz).then((result) => {
          if (result.status === "Success") {
            ////کدهای ثبت انتقال وجه
            const formData = new FormData();
            if (this.Result != null) {
              formData.append("wwwtblTaahodatIdBestanKar", this.Result.id);
            } else {
              formData.append("wwwtblTaahodatIdBestanKar", this.Resultcmb2.id);
            }
            formData.append("wwwtblTaahodatIdBedehKar", this.Resultcmb.id);
            formData.append("Mablagh", this.txtMablagh);
            formData.append("Desc", this.Description);
            formData.append("KodRahgiri", "");
            formData.append("CardNo", "");
            formData.append("ShebaNo", "");
            formData.append(
              "NameSahebHesab",
              this.$session.get("UserInfoNetPa").ozvName +
                " " +
                this.$session.get("UserInfoNetPa").ozvFamily,
            );
            formData.append("EnteghalNoe", 2);
            formData.append("HesabNo", "");
            formData.append("OrderId", "-2");
            formData.append("MabKarmozdEnteghal", 0);
            formData.append("MabKarmozdBnp", 0);
            formData.append("BankName", "");
            formData.append("ComboIdGrp324", 0);
            formData.append("TarixSanad", this.$store.state.JalaliDate);
            formData.append("VarizGorohiId", result.idRepoMaster);
            formData.append("wwwJarime", this.MabFormulaJarime);
            formData.append("userInput", this.captchaText);
            formData.append("captchaId", this.captchaId);
            this.DataAxios_Enteghal.ArryfildValue = formData;
            if (!this.$OnceGuard("EnteghalVajh", 8000)) return; // NetPa HANDOFF S14 : double-submit
            this.$PostFormData(this.DataAxios_Enteghal).then((data) => {
              if (data.id > 0 && data.success == "SUCCESS") {
                this.$mySweetDefaultTost(
                  "انتقال موفق",
                  "انتقال وجه با موفقیت انجام شد کد رهگیری : " +
                    data.codeRahgiri,
                  "success",
                  6000,
                );
                Object.assign(this.$data, this.$options.data.call(this));
                this.GetData();
                this.refreshCaptcha();
              } else {
                this.$mySweetDefaultTost(
                  "مشکل در انتقال وجه",
                  "مشکلی در انتقال وجه پیش آمده لطفا مجددا تلاش کنید",
                  "warning",
                  3000,
                );
                this.refreshCaptcha();
              }
            });

            ////کدهای ثبت انتقال وجه
          }
        });
      } else {
        ////کدهای ثبت انتقال وجه
        const formData = new FormData();
        formData.append(
          "wwwtblAzaId",
          this.$session.get("UserInfoNetPa").wwwtblAzaId,
        );
        if (this.Result != null) {
          formData.append("wwwtblTaahodatIdBestanKar", this.Result.id);
        } else {
          formData.append("wwwtblTaahodatIdBestanKar", this.Resultcmb2.id);
        }
        formData.append("wwwtblTaahodatIdBedehKar", this.Resultcmb.id);
        formData.append("Mablagh", this.txtMablagh);
        formData.append("Desc", this.Description);
        formData.append("KodRahgiri", "");
        formData.append("CardNo", "");
        formData.append("ShebaNo", "");
        formData.append(
          "NameSahebHesab",
          this.$session.get("UserInfoNetPa").ozvName +
            " " +
            this.$session.get("UserInfoNetPa").ozvFamily,
        );
        formData.append("EnteghalNoe", 2);
        formData.append("HesabNo", "");
        formData.append("OrderId", "-2");
        formData.append("MabKarmozdEnteghal", 0);
        formData.append("MabKarmozdBnp", 0);
        formData.append("BankName", "");
        formData.append("ComboIdGrp324", 0);
        formData.append("TarixSanad", this.$store.state.JalaliDate);
        formData.append("VarizGorohiId", 0);
        formData.append("wwwJarime", this.MabFormulaJarime);
        formData.append("userInput", this.captchaText);
        formData.append("captchaId", this.captchaId);
        this.DataAxios_Enteghal.ArryfildValue = formData;
        if (!this.$OnceGuard("EnteghalVajh", 8000)) return; // NetPa HANDOFF S14 : double-submit
        this.$PostFormData(this.DataAxios_Enteghal).then((data) => {
          if (data.id > 0 && data.success == "SUCCESS") {
            this.$mySweetDefaultTost(
              "انتقال موفق",
              "انتقال وجه با موفقیت انجام شد کد رهگیری : " + data.codeRahgiri,
              "success",
              6000,
            );
            Object.assign(this.$data, this.$options.data.call(this));
            this.GetData();
            this.refreshCaptcha();
          } else {
            this.$mySweetDefaultTost(
              "مشکل در انتقال وجه",
              "مشکلی در انتقال وجه پیش آمده لطفا مجددا تلاش کنید",
              "warning",
              3000,
            );
            this.refreshCaptcha();
          }
        });

        ////کدهای ثبت انتقال وجه
      }
    },
    SaveDataShebaOrCard() {
      return new Promise((success, reject) => {
        let Data = {
          Id: 0,
          wwwtblAzaId: this.$session.get("UserInfoNetPa").wwwtblAzaId,
          IsSheba: false,
          SahebShebaOrCard: this.Result.nameFamily + " _ " + this.Result.desNoe,
          ShebaOrCardNum: this.Result.vCode,
          IsBardasht: false,
        };
        var DataAxiosFindShebaOrCard = {
          ArryfildValue: Data,
          Method: "Post",
          Action: "ShebaOrCard",
          Token: this.$session.get("TokenNetPa"),
        };
        this.$PostData(DataAxiosFindShebaOrCard).then((data) => {
          if (data.status == "Success") {
            success(true);
          }
          // else if(data.status == 'Dup') {
          //   //اطلاعات شبا و یا کارت تکراری بوده
          // }
          else {
            //خطا در ذخیره
          }
        });
      });
    },
    Cancel() {},
    GetDataShebaOrCard() {
      var DataAxios = {
        ArryfildValue: "",
        Method: "post",
        Action: "ShebaOrCard/GetShebaOrCard",
        Token: this.$session.get("TokenNetPa"),
      };
      const formData = new FormData();
      formData.append(
        "wwwtblAzaId",
        this.$session.get("UserInfoNetPa").wwwtblAzaId,
      );
      DataAxios.ArryfildValue = formData;
      this.$PostFormData(DataAxios).then((data) => {
        data.forEach((value) => {
          value["select"] = false;
        });
        this.ListSaveHesab = data.filter((x) => x.isBardasht == false);
        this.KEY++;
      });
    },
    SelectSaveHesab(id) {
      this.ListSaveHesab.forEach((el) => {
        if (el.id == id) {
          el.selected = true;
          this.ShebaNo = el.shebaOrCardNum;
          this.NameSahebHesab = el.sahebShebaOrCard;
          this.VCode = el.shebaOrCardNum;
          this.CheckupVcode();
          this.KEY++;
        } else {
          el.selected = false;
        }
      });

      this.SaveDetailHesab = false;
      this.IsHesab = false;
      this.transferDestType = "others";
    },
    RemoveShebeOrCard(row) {
      this.$SweetQustion(
        "اطمینان ازحذف",
        " از حذف شماره حساب و یا تسهیلات " +
          row.shebaOrCardNum +
          " به نام  " +
          row.sahebShebaOrCard +
          " اطمینان دارید ؟ ",
        "question",
        "تایید حذف",
        "انصراف",
        row.id,
        this.ConfirmRemoveShebaOrCard,
        this.isNotConfirmed,
      );
    },
    ConfirmRemoveShebaOrCard(id) {
      var DataAxios = {
        ArryfildValue: "",
        Method: "Post",
        Action: "ShebaOrCard/DeleteShebaOrCard",
        Token: this.$session.get("TokenNetPa"),
      };
      const formData = new FormData();
      formData.append("wwwtbShebaOrCardId", id);
      DataAxios.ArryfildValue = formData;
      this.$PostFormData(DataAxios).then((data) => {
        if (data.status == "Success") {
          this.GetDataShebaOrCard();
          this.KEY++;
          this.$mySweetDefaultTost(
            "حذف موفق",
            " حذف شماره شبا یا شماره کارت انتخابی شما با موفقیت انجام شد",
            "success",
            2000,
          );
        }
      });
    },
    isNotConfirmed() {},
  },
  computed: {
    GetMablagh() {
      return (
        " انتقال  " + this.$Comma3ragham(this.txtMablagh) + this.$GetVahedPool()
      );
    },
    sourceAccount() {
      const r = this.Resultcmb;
      if (!r || r == "-1" || typeof r !== "object") return null;
      return r;
    },
    Mab2persian() {
      const Mab = Number(String(this.txtMablagh || "").replace(/,/g, ""));
      if (!Mab || isNaN(Mab)) return "";
      return " مبلـغ " + Num2persian(Mab) + " " + this.$GetVahedPool();
    },
  },
};
</script>
<style scoped>
#transfer {
  --t-primary: #435ebe;
  --t-primary-soft: #eef1fb;
  --t-primary-dark: #34499a;
  --t-border: #e3e7f1;
  --t-text: #2b3245;
  --t-muted: #6b7491;
  --t-success: #1f9d6b;
  --t-warning: #e0932b;
  --t-danger: #d64545;
}

/* ---------- Layout ---------- */
.Transfer-form {
  max-width: 560px;
  margin: 0 auto;
  padding: 0.5rem 0;
  color: var(--t-text);
}

/* ---------- Fields ---------- */
.Transfer-field {
  margin-bottom: 1rem;
}
.Transfer-field--spaced {
  margin-top: 1.25rem;
}
.Transfer-label {
  display: block;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--t-muted);
  margin-bottom: 0.4rem;
}
.Transfer-form .form-control {
  height: 46px;
  border-radius: 10px;
  border: 1px solid var(--t-border);
  background: #fafbfe;
  transition: border-color 0.15s ease, box-shadow 0.15s ease,
    background 0.15s ease;
}
.Transfer-form .form-control:focus {
  background: #fff;
  border-color: var(--t-primary);
  box-shadow: 0 0 0 3px rgba(67, 94, 190, 0.15);
}
.Transfer-form .form-control:disabled {
  background: #f0f2f8;
  color: var(--t-muted);
}
.Transfer-form textarea.form-control {
  height: auto;
}
.Transfer-form input[type="number"] {
  -moz-appearance: textfield;
  appearance: textfield;
}
.Transfer-form input[type="number"]::-webkit-outer-spin-button,
.Transfer-form input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.Transfer-captcha ::v-deep .input-group {
  margin-bottom: 0 !important;
}
.Transfer-captcha ::v-deep .input-group > .form-control {
  height: 46px;
  min-height: 46px;
  border: 1px solid var(--t-border);
  border-radius: 10px 0 0 10px;
  background: #fafbfe;
  transition: border-color 0.15s ease, box-shadow 0.15s ease,
    background 0.15s ease;
}
.Transfer-captcha ::v-deep .input-group > .form-control:focus {
  background: #fff;
  border-color: var(--t-primary);
  box-shadow: 0 0 0 3px rgba(67, 94, 190, 0.15);
}
.Transfer-captcha ::v-deep .input-group-text {
  height: 46px;
  border: 1px solid var(--t-border);
  border-left: 0;
  border-radius: 0 10px 10px 0;
  background: #fff;
  object-fit: contain;
}
.Transfer-skeleton {
  height: 46px;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0 0.9rem;
  border-radius: 10px;
  background: #f0f2f8;
  color: var(--t-muted);
  font-size: 0.875rem;
}
.Transfer-link-btn {
  background: none;
  border: 0;
  padding: 0;
  color: var(--t-primary);
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
}
.Transfer-link-btn:hover {
  color: var(--t-primary-dark);
  text-decoration: underline;
}

/* ---------- Balance ---------- */
.Transfer-balance {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.95rem 1.1rem;
  border-radius: 12px;
  color: #fff;
  background: linear-gradient(135deg, #435ebe, #5f78d6);
}
.Transfer-balance.is-empty {
  background: linear-gradient(135deg, #a9b2cf, #c0c7de);
}
.Transfer-balance__label {
  font-size: 0.85rem;
  opacity: 0.9;
}
.Transfer-balance__value {
  font-size: 1.3rem;
  font-weight: 700;
  letter-spacing: 0.2px;
}
.Transfer-balance__value small {
  color: #fff !important;
  font-size: 0.75rem;
  font-weight: 500;
  opacity: 0.85;
  margin-right: 0.2rem;
}
.Transfer-meta {
  margin-top: 0.6rem;
  padding: 0.6rem 1rem;
  border: 1px solid var(--t-border);
  border-radius: 12px;
  background: #fafbfe;
  font-size: 0.82rem;
  color: var(--t-muted);
}
.Transfer-meta__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.2rem 0;
}
.Transfer-meta__row b {
  color: var(--t-text);
}

/* ---------- Segmented control ---------- */
.Transfer-segmented {
  display: flex;
  gap: 0.25rem;
  padding: 0.25rem;
  border-radius: 12px;
  background: #eef0f7;
}
.Transfer-segment {
  position: relative;
  flex: 1 1 0;
  min-width: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  padding: 0.6rem 0.5rem;
  border-radius: 9px;
  color: var(--t-muted);
  font-size: 0.9rem;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  user-select: none;
  transition: background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;
}
.Transfer-segment input {
  position: absolute;
  opacity: 0;
  inset: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  cursor: pointer;
}
.Transfer-segment:hover {
  color: var(--t-text);
}
.Transfer-segment.is-active {
  background: #fff;
  color: var(--t-primary);
  box-shadow: 0 1px 4px rgba(35, 48, 90, 0.15);
}
.Transfer-segment:focus-within {
  outline: 2px solid rgba(67, 94, 190, 0.45);
  outline-offset: 1px;
}
@media (max-width: 420px) {
  .Transfer-segment {
    font-size: 0.8rem;
    gap: 0.3rem;
  }
}

/* ---------- Account number check ---------- */
.Transfer-vcode {
  display: flex;
  align-items: stretch;
  gap: 0.5rem;
}
.Transfer-vcode .form-control {
  flex: 1 1 auto;
  min-width: 0;
  font-weight: 600;
  letter-spacing: 1px;
}
.Transfer-vcode__check {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0 0.9rem;
  border: 0;
  border-radius: 10px;
  background: var(--t-primary);
  color: #fff;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease;
}
.Transfer-vcode__check:hover {
  background: var(--t-primary-dark);
}
@media (max-width: 420px) {
  .Transfer-vcode__check span {
    display: none;
  }
}

/* ---------- Account check result ---------- */
.Transfer-estelam {
  margin-bottom: 1rem;
  padding: 0.75rem 1rem;
  border: 1px solid #bfe6d4;
  border-radius: 12px;
  background: #f2fbf7;
  font-size: 0.85rem;
}
.Transfer-estelam__row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.35rem 0;
}
.Transfer-estelam__row + .Transfer-estelam__row {
  border-top: 1px dashed #cfe9dd;
}
.Transfer-estelam__row > span {
  flex: 0 0 auto;
  color: var(--t-muted);
}
.Transfer-estelam__row > b {
  text-align: left;
}

/* ---------- Saved accounts ---------- */
.Transfer-saved {
  margin-bottom: 1rem;
  padding: 0.85rem;
  border: 1px solid var(--t-border);
  border-radius: 12px;
  background: #f6f7fc;
}
.Transfer-saved__head {
  margin-bottom: 0.6rem;
  font-size: 0.85rem;
  font-weight: 700;
  color: var(--t-text);
}
.Transfer-saved__list {
  max-height: 260px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.Transfer-saved__empty {
  padding: 1rem;
  text-align: center;
  color: var(--t-muted);
  font-size: 0.85rem;
}
.Transfer-saved__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.65rem 0.85rem;
  border: 1px solid var(--t-border);
  border-radius: 10px;
  background: #fff;
}
.Transfer-saved__item.is-selected {
  border-color: var(--t-success);
  background: #f2fbf7;
}
.Transfer-saved__info {
  min-width: 0;
}
.Transfer-saved__num {
  font-weight: 700;
  letter-spacing: 0.5px;
  word-break: break-all;
  text-align: right;
}
.Transfer-saved__owner {
  font-size: 0.8rem;
  color: var(--t-muted);
}
.Transfer-saved__actions {
  flex: 0 0 auto;
  display: flex;
  gap: 0.35rem;
}
.Transfer-icon-btn {
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 8px;
  background: #eef0f7;
  color: var(--t-muted);
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}
.Transfer-icon-btn.is-select:hover {
  background: var(--t-primary);
  color: #fff;
}
.Transfer-icon-btn.is-remove:hover {
  background: var(--t-danger);
  color: #fff;
}
.Transfer-icon-btn.is-done {
  background: var(--t-success);
  color: #fff;
  cursor: default;
}

/* ---------- Save switch ---------- */
.Transfer-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  min-height: 46px;
  margin: 0;
  padding: 8px 12px;
  border: 1px solid var(--t-border);
  border-radius: 10px;
  background: #fff;
  color: var(--t-text);
  font-size: 0.85rem;
  font-weight: 600;
  line-height: 1.5;
  cursor: pointer;
}
.Transfer-switch {
  position: relative;
  display: inline-flex;
  flex-shrink: 0;
}
.Transfer-switch input {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: 0;
  opacity: 0;
}
.Transfer-switch__track {
  position: relative;
  display: block;
  width: 36px;
  height: 20px;
  border-radius: 999px;
  background: #d5dee6;
  transition: background 180ms ease;
}
.Transfer-switch__track::after {
  content: "";
  position: absolute;
  top: 3px;
  right: 3px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(19, 36, 58, 0.22);
  transition: transform 180ms ease;
}
.Transfer-switch input:checked + .Transfer-switch__track {
  background: linear-gradient(110deg, #29345f, #05b8c8);
}
.Transfer-switch input:checked + .Transfer-switch__track::after {
  transform: translateX(-16px);
}
.Transfer-switch input:focus-visible + .Transfer-switch__track {
  box-shadow: 0 0 0 4px rgba(5, 184, 200, 0.22);
}
@media (prefers-reduced-motion: reduce) {
  .Transfer-switch__track,
  .Transfer-switch__track::after {
    transition: none;
  }
}

/* ---------- Amount ---------- */
.Transfer-amount {
  position: relative;
}
.Transfer-form .Transfer-amount__input {
  height: 62px;
  padding-left: 4.5rem;
  padding-right: 1rem;
  font-size: 1.6rem !important;
  font-weight: 700;
  text-align: center;
  letter-spacing: 0.5px;
}
.Transfer-amount__unit {
  position: absolute;
  top: 50%;
  left: 1rem;
  transform: translateY(-50%);
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--t-muted);
  pointer-events: none;
}
.Transfer-amount__foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  min-height: 1.6rem;
  margin-top: 0.5rem;
}
.Transfer-amount__words {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--t-primary);
}

/* ---------- Submit ---------- */
.Transfer-submit {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  min-height: 54px;
  padding: 0.5rem 1.25rem;
  border: 0;
  border-radius: 12px;
  background: linear-gradient(135deg, #435ebe, #5770c9);
  color: #fff;
  font-size: 1.05rem;
  font-weight: 700;
  box-shadow: 0 6px 16px rgba(67, 94, 190, 0.3);
  cursor: pointer;
  transition: transform 0.1s ease, box-shadow 0.15s ease, opacity 0.15s ease;
}
.Transfer-submit:hover:not(:disabled) {
  box-shadow: 0 8px 20px rgba(67, 94, 190, 0.4);
  transform: translateY(-1px);
}
.Transfer-submit:disabled {
  background: #c5cbdd;
  box-shadow: none;
  cursor: not-allowed;
}
.Transfer-submit--sm {
  width: auto;
  min-height: 46px;
  padding: 0 1.5rem;
  font-size: 0.95rem;
  background: var(--t-success);
  box-shadow: none;
}
.Transfer-twostep {
  margin-top: 1.25rem;
  padding-top: 1.25rem;
  border-top: 1px dashed var(--t-border);
}
.Transfer-twostep__row {
  display: flex;
  gap: 0.5rem;
}
.Transfer-twostep__row .form-control {
  flex: 1 1 auto;
}

@media (max-width: 575px) {
  .Transfer-balance__value {
    font-size: 1.1rem;
  }
}
</style>
